import { render } from "./OrdersStatsSection.vue?vue&type=template&id=cfd863cc"
import script from "./OrdersStatsSection.vue?vue&type=script&lang=js"
export * from "./OrdersStatsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__